'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('path', {
                fill: '#FFCF3F',
                d: 'M35.678 30.89h5.701v1.575l-1.06 2.439v15.108l-1.79 1.67-1.995-1.67V34.904l-.856-2.44z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFEDBB',
                d: 'M6.358 35.137l1.445-2.556h23.708l1.532 2.556v1.646H6.358z'
            }),
            _react2.default.createElement('path', {
                fill: '#F7F7F8',
                d: 'M10.9 57.034L8.5 36.92h22.398l-1.985 20.113z'
            }),
            _react2.default.createElement('path', {
                d: 'M32.813 36.563H6.563v-1.876c0-1.034.84-1.874 1.875-1.874h22.5c1.035 0 1.875.84 1.875 1.874v1.876z',
                stroke: '#3F5060',
                strokeWidth: '1.875'
            }),
            _react2.default.createElement('path', {
                stroke: '#3F5060',
                strokeWidth: '1.875',
                d: 'M29.063 57.188h-18.75L8.437 36.561h22.5zM0 57.188h60'
            }),
            _react2.default.createElement('path', {
                d: 'M34.688 5.625v3.75M34.688 1.875V3.75M38.438 3.75v5.625M38.438 0v1.875M42.188 3.75v5.625M42.188 0v1.875M45.938 5.625v3.75M45.938 1.875V3.75M30.938 3.75v5.625M30.938 0v1.875M30.938 0v1.875',
                stroke: '#00D8C8',
                strokeWidth: '1.875'
            }),
            _react2.default.createElement('path', {
                stroke: '#A7F2EB',
                strokeWidth: '1.875',
                d: 'M5.625 25.313h11.25v-5.625H3.75M11.25 14.063v5.624M16.875 19.688H22.5M7.5 14.063h13.125M16.875 7.5v6.563M45 42.188h15M48.75 47.813H60M56.25 42.188v5.624M43.125 36.563h15M50.625 36.563v5.624M13.125 7.5v1.875M20.625 24.375v1.875M.938 18.75v1.875M46.875 47.813H45'
            }),
            _react2.default.createElement('path', {
                d: 'M24.375 37.5v6.563M24.375 45.938v1.874M20.625 45v-7.5',
                stroke: '#FFCF3F',
                strokeWidth: '1.875'
            }),
            _react2.default.createElement('path', {
                stroke: '#3F5060',
                strokeWidth: '1.875',
                d: 'M38.438 30.938v-3.75l15-5.625V15h-3.75v3.75h-22.5V9.375h22.5v2.813M27.188 14.063h-2.813'
            }),
            _react2.default.createElement('path', {
                d: 'M36.563 30.938h-.938v1.875l.938 1.874v15a1.876 1.876 0 0 0 3.75 0v-15l.937-1.874v-1.876h-4.688z',
                stroke: '#3F5060',
                strokeWidth: '1.875'
            })
        )
    );
};

DefaultIcon.defaultProps = {
    width: '60',
    height: '59',
    viewBox: '0 0 60 59',
    xmlns: 'http://www.w3.org/2000/svg'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;